// Event albums: cover tile opens an inline panel, any photo opens a lightbox.
// Runs once per section; the section passes its own id in.
// Captions are deliberately not displayed - the text after the | on each photo
// line is used as alt text only.
window.ssAlbums = function (sectionId) {
  const root = document.getElementById('alb-' + sectionId);
  if (!root || root.dataset.albReady) return;
  root.dataset.albReady = '1';

  const panels = [...root.querySelectorAll('[data-alb-panel]')];
  const grid = root.querySelector('[data-alb-grid]');
  const box = root.querySelector('[data-alb-box]');
  const boxImg = root.querySelector('[data-alb-boximg]');
  let shots = [];
  let at = 0;

  const closePanels = () => {
    panels.forEach((p) => { p.hidden = true; });
    root.querySelectorAll('[data-alb-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  };

  root.querySelectorAll('[data-alb-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const i = btn.dataset.albOpen;
      const panel = panels.find((p) => p.dataset.albPanel === i);
      if (!panel) return;
      const wasOpen = !panel.hidden;
      closePanels();
      if (wasOpen) return;
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  root.querySelectorAll('[data-alb-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      closePanels();
      grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  const show = (i) => {
    if (!shots.length) return;
    at = (i + shots.length) % shots.length;
    const img = shots[at];
    boxImg.src = img.dataset.albFull;
    boxImg.alt = img.alt || '';
  };

  const openBox = (img) => {
    shots = [...img.closest('.ss-alb__photos').querySelectorAll('img')];
    box.hidden = false;
    document.body.style.overflow = 'hidden';
    show(shots.indexOf(img));
  };

  const closeBox = () => {
    box.hidden = true;
    // An empty src resolves to the page URL and fires a pointless request,
    // so drop the attribute instead of blanking it.
    boxImg.removeAttribute('src');
    document.body.style.overflow = '';
  };

  root.querySelectorAll('.ss-alb__photos img').forEach((img) => {
    img.addEventListener('click', () => openBox(img));
  });

  root.querySelector('[data-alb-prev]').addEventListener('click', () => show(at - 1));
  root.querySelector('[data-alb-next]').addEventListener('click', () => show(at + 1));
  root.querySelector('[data-alb-boxclose]').addEventListener('click', closeBox);
  box.addEventListener('click', (e) => { if (e.target === box) closeBox(); });

  document.addEventListener('keydown', (e) => {
    if (box.hidden) return;
    if (e.key === 'Escape') closeBox();
    if (e.key === 'ArrowLeft') show(at - 1);
    if (e.key === 'ArrowRight') show(at + 1);
  });
};
